<script>
import { HomeIcon, MailIcon } from "vue-feather-icons";
import appConfig from "@/app.config";

export default {
  data() {
    return {
      appConfig: appConfig,
    };
  },
  components: {
    MailIcon,
    HomeIcon,
  },
  metaInfo() {
    return {
      title: '비밀번호 찾기 | 대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '대구여성인권센터 비밀번호 찾기 페이지입니다.'
        },
        {
          property: 'og:title',
          content: '비밀번호 찾기 | 대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '대구여성인권센터 비밀번호 찾기 페이지입니다.'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '비밀번호 찾기 | 대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '대구여성인권센터 비밀번호 찾기 페이지입니다.'
        }
      ]
    }
  },
};
</script>

<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <router-link to="/" class="btn btn-icon btn-primary">
        <home-icon class="icons"></home-icon>
      </router-link>
    </div>

    <!-- Hero Start -->
    <section class="bg-derc-member navwave-2 d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-6">
            <div class="media features p-4 bg-primary rounded mr-lg-5">
              <router-link class="logo-footer" to="/">
                <div class="text-bold text-white">
                  <img :src="`${appConfig.url}/images/_decen/logo/logo_old.png`" width="24" alt="" />대구여성인권센터
                </div>
                <div>
                  <span><i class="mdi mdi-shield-off img-fluid mx-auto d-block member-login-img mover text-primary"></i></span>
                </div>
              </router-link>
            </div>
          </div>
          <div class="col-lg-5 col-md-6">
            <div class="card shadow rounded border-0">
              <div class="card-body">
                <h4 class="card-title text-center text-bold text-primary">비밀번호 찾기</h4>

                <form class="login-form mt-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <p class="text-muted font-size-14">
                        이메일 주소를 입력해주세요. <br />
                        이메일을 통해 새 비밀번호를 생성할 수 있는 링크를 받게 됩니다.
                      </p>
                      <div class="form-group">
                        <label>
                          Email address<span class="text-danger">*</span>
                        </label>
                        <div class="position-relative">
                          <mail-icon class="fea icon-sm icons"></mail-icon>
                          <input
                            type="email"
                            class="form-control pl-5"
                            placeholder="***@이메일주소.com"
                            name="email"
                            required=""
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <button class="btn btn-primary btn-block">전송</button>
                    </div>
                    <div class="mx-auto">
                      <p class="mb-0 mt-3">
                        <small class="text-dark mr-2">비밀번호가 기억나시나요?</small>
                        <router-link to="/member-login" class="text-primary font-weight-bold">로그인하기</router-link>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
